import { Routes, Route, BrowserRouter } from "react-router";
import './App.css';

import MainPage from './components/MainPage'

function App() {
  return (
    <div className="App">
      <BrowserRouter>
          <Routes>
            <Route path="/" element={<MainPage />}/> 
          </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
